<template>
   <div class="h-100 w-100" style="display:inline-block">
       <div style="height:50px;" class="comm-settings-top-nav">
        <div class="justify-content-start" style="width:100%;">
            <nav aria-label="breadcrumb">
            <ol class="breadcrumb comm-settings-top-nav m-0">
                <li>
                <back-button v-on:click.native="changeToSelectedwebhookComponent('show-webhook')" style="position: relative;"></back-button>
                </li>
                <li class="breadcrumb-item active-text-nav-bar mt-1" aria-current="page" style="font-size:17px;">{{selectedWebHookName}}</li>
            </ol>
            </nav>
        </div>
        </div>
       <div class="web-hook-main-wrapper w-100" style="display:inlin-block;padding:0px 20px;height:calc(100% - 135px);overflow:auto">
           <div class="col-md-12 h-100">
               <div class="w-100 comm-field-div" style="display:inline-block;padding:0px 20px;">
                    <h6 style="width: 60px;display: flex;float: inline-start;height: 40px;align-items: center;margin: 0px 5px;text-align: center;color:#757575;"> {{$t('Name')}} </h6>
                    <input v-if="!isEditMode" v-model="hookscriptName" class="rounded text-light input-fields" type="text" :placeholder="$t('Enter Name')" autocomplete="off" style="float:inline-start;width:50%;">
              
                    <div v-else style="width:80%;display: inline-block;height:40px;float:inline-start"> 
                        <div :style="isWebHookNameEditing?'width:50% !important':'width:auto !important'" style="display: inline-block;height:40px;float: inline-start;">
                            <div class="d-inline-flex edit-icon-visibility" :style="isWebHookNameEditing?'height:0%':'height:100%'" style="float:inline-start;">
                            <span v-if="!isWebHookNameEditing" :title="selectedWebhookInfo.hookscript_name" style="font-size: 16px; display: flex; position: relative;  margin-inline-end: 10px; word-break: break-word;align-items: center;">
                                {{selectedWebhookInfo.hookscript_name}}
                            </span>
                            
                            <edit-icon
                                @click.native="isWebHookNameEditing = true, webHookNameEdited = selectedWebhookInfo.hookscript_name"
                                v-if="!isWebHookNameEditing"
                                class="edit-icon"
                            ></edit-icon>

                            </div>
                            <input
                            minlength="3"
                            type="text"
                            v-model="webHookNameEdited"
                            v-if="isWebHookNameEditing"
                            class="rounded text-light comm-input-field-style review-heading-input"
                            placeholder="Enter Title"
                            style="height: 40px;position: relative;font-size: 16px;width: 99% !important;float: inline-start;max-width: 99%;border: 1px solid #828282;padding-inline-start: 5px;"
                            required
                            />
                        </div>
                        <div v-if="isWebHookNameEditing" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                            <div class="d-flex" style="height: 100%;align-items: center;">
                            <save-icon
                            @click.native="updateWebHookFields('hookscript_name',webHookNameEdited)"
                            ></save-icon>
                            
                            <cancel-icon
                                @click.native="cancelSelectedWebHookFields('hookscript_name')" >
                            </cancel-icon>
                            </div>
                        </div>
                    </div>

               </div>
               <div class="w-100 comm-field-div" style="display:inline-block;padding:0px 20px;margin-bottom:0px !important">
                    <div style="display:inline-flex;width:100%">
                        <h6 style="display: inline-block;float:inline-start;height:40px;align-items:center;margin:0px 5px;text-align:start;color:#757575;position: relative;top: 3px;"> {{$t('Workflow')}} </h6>
                        <div class="custom-control custom-switch" style="display: inline-flex;padding-inline-start:4%">
                            <input
                                v-on:click="toggletriggers"
                                type="checkbox"
                                class="custom-control-input"
                                id="triggersBtn"
                                ref = "tiggersEnable"
                            />
                            <label class="custom-control-label" for="triggersBtn">
                                <!-- <span>Bin changed</span> -->
                             </label>    
                        </div>
                    </div>    
                    <div v-show="!isWorkflowEnabled" ref="triggersList" style="width:100%;transition:0.4s">
                        <h6 style="display: inline-flex;align-items:center;float:inline-start;height:40px;align-items:center;margin:0px 5px;text-align:start;width:100%;color:#757575;"> {{$t('Triggers')}} </h6>
                        <ul style="display:inline-block;padding:0px 20px;width:100%">
                            <li class="col-md-4" v-for="trigger in triggersList" :key="trigger._id" style="list-style:none;display:inline-block;float:inline-start;padding: 7px 12px;">
                                 <div class="w-100 custom-control custom-switch triggers-item" style="display: inline-flex;">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        :id="trigger.trigger_id"
                                        @click="updateTriggersValue(trigger.trigger_id)"
                                    />
                                    <label class="custom-control-label" :for="trigger.trigger_id">
                                        <span>{{trigger.trigger_name?trigger.trigger_name:trigger.name}}</span>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </div> 
               </div>
               <div class="w-100" style="display:inline-block;padding:0px 20px">
                   <h6 style="display: inline-flex;align-items:center:float:inline-start;height:40px;align-items:center;margin:0px 5px;text-align:start;width:100%;color:#757575;"> URL </h6>
                    <span style="width: 125px; display: flex;  height: 40px; align-items: center;  border: 1px solid #4a4a4a;float: inline-start;border-inline-end: 0px !important;justify-content: center;    border-radius: 4px 0px 0px 4px;background: #373737;"> POST </span>
                    <div class="">    
                        <input v-model="webHookUrl" class="rounded text-light input-fields edit-icon-visibility" type="text" placeholder="Enter URL" autocomplete="off" :readonly="isEditMode && isWebHookUrlEditing == 0" :style="isEditMode && isWebHookUrlEditing == 0?'cursor: not-allowed;':'cursor:text'" style="float:inline-start;width:calc(100% - 125px - 8%);margin:0px;border-radius: 0px 4px 4px 0px !important;">
                        <div :style="isEditMode && !isWebHookUrlEditing?'width:8%;display:inline-block':'width:0px;display:none'">        
                            <edit-icon
                                @click.native="isWebHookUrlEditing = true"
                                v-if="isEditMode && !isWebHookUrlEditing"
                                class="placed-edit-icon"
                                style="float:inline-start;margin-inline-start:15px;"
                            ></edit-icon>
                        </div>    
                        <div v-if="isWebHookUrlEditing" class="taskTitleSaveUnsaveBtns" style="height: 40px;display: inline-block;float: inline-start;">
                            <div class="d-flex" style="height: 100%;align-items: center;">
                                <save-icon
                                @click.native="updateWebHookFields('url',webHookUrl)"
                                ></save-icon>
                            
                                <cancel-icon
                                    @click.native="cancelSelectedWebHookFields('url')" >
                                </cancel-icon>
                            </div>
                        </div>
                        <span class="comm-helper-label" style="position:relative;inset-inline-start:130px;float:inline-start"> Eg: https://192.168.0.1/messages,  http://192.168.0.1/files</span>
                    </div>    
               </div>
                <div class="rounded" style="margin-top:45px;">               
                    <div class="navbar-wrapper w-100">
                        <nav class="navbar navbar-expand-lg p-0">
                            <div id="webhookNavbar" class="collapse navbar-collapse">
                                <div class="navbar-nav w-100 top-nav-bar" style="width: 92% !important;display: inline-block;">
                                    <a class="nav-link" @click="switchHeaderAndBodyTab('header')" :class='(activeIndex === "header")?"activeTab":"inactiveTab"' style="width: 15% !important;float: inline-start;display: inline-block;">{{$t('Header')}}</a>
                                    <a class="nav-link" @click="switchHeaderAndBodyTab('body')" :class='(activeIndex === "body")?"activeTab":"inactiveTab"' style="width: 15% !important;float: inline-start;display: inline-block;">{{$t('Body')}}</a>
                                    <a class="nav-link" @click="switchHeaderAndBodyTab('alias')" :class='(activeIndex === "alias")?"activeTab":"inactiveTab"' style="width: 15% !important;float: inline-start;display: inline-block;">{{$t('Alias')}}</a>
                                </div>
                            </div>
                        </nav>
                    </div> 
                    <div class="webhook-form-data-wrapper">
                        <div v-show="activeIndex == 'header'" class="header-section">
                            <div class="common-input-field description-edit-icon-visibility" style="position:relative;padding:0px 20px 20px 20px;">
                                <table v-if="!isEditMode" class="web-hook-headers-table table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px;padding-inline-start: 18px;">
                                                <div class="placed-edit-icon" @click="addOneRowForHeader('web-hook-headers-table')" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div>   
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in addingHeaderRowArr" :key="index">
                                            <td>
                                                <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td>
                                                <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td style='text-align: start; padding: 0px;padding-inline-start: 18px;'>
                                                <div class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"   width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                    </svg>
                                                </div>  
                                            </td>
                                        </tr>   
                                    </tbody>
                                </table> 
                                <table v-if="isEditMode && !isHeadersEditing" class="web-hook-headers-table-edit-readonly table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px;padding-inline-start: 18px;">
                                                <div class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg  @click="allowToEditHeaders()" data-v-7efae477="" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-pen-fill">
                                                        <path data-v-7efae477="" fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"></path>
                                                    </svg>
                                                </div>    
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="Object.keys(headerValuesObj).length">
                                        <template v-for="(value, name, index) in headerValuesObj">
                                            <tr :key="index">
                                                <td>{{name}}</td>
                                                <td>{{value}}</td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </tbody>    
                                </table> 
                                <table v-if="isEditMode && isHeadersEditing" class="web-hook-headers-table-editable table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px;padding-inline-start: 18px;"> 
                                                <div class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg @click="addOneRowForHeader('web-hook-headers-table-editable')" xmlns="http://www.w3.org/2000/svg"  width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div> 
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(row, index) in editableHeaderRowArr">
                                            <tr :key="index" class="editing-header-row">
                                                <td>
                                                    <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td>
                                                    <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td style='padding: 0px;padding-inline-start: 18px;'>
                                                    <div class="placed-edit-icon"  @click="removeRowFromTable('web-hook-headers-table-editable', index)" style="display: flex;align-items: center;justify-content: center;">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                        </svg>
                                                    </div>  
                                                </td>
                                            </tr> 
                                        </template>     
                                        
                                    </tbody> 
                                </table> 
                                <div v-if="isEditMode && this.isHeadersEditing" class="web-hook-primary-btn-style" style="padding-inline-end:15px;">
                                    <button @click="updateWebHookFields('headers')" class="btn btn-outline-primary" style="float:inline-end">
                                    {{$t('Save')}}
                                    </button>
                                    <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="cancelEditedTableChanges('editing-header-row')" style="float:inline-end">{{$t('Cancel')}}</button>
                                </div>   
                            </div>    
                        </div> 
                        <div v-show="activeIndex == 'body'" class="header-section">
                            <div class="common-input-field description-edit-icon-visibility" style="position:relative;padding:0px 20px 20px 20px;">
                                <table v-if="!isEditMode" class="web-hook-body-table table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div class="placed-edit-icon" @click="addOneRowForHeader('web-hook-body-table')" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div> 
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in addingBodyRowArr" :key="index">
                                            <td>
                                                <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td>
                                                <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td style='text-align: start; padding: 0px 0px 0px 18px;'>
                                                <div class="placed-edit-icon" @click="removeRowFromTable('web-hook-body-table', index)" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"  width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                        </svg>
                                                </div>  
                                            </td>
                                        </tr>   
                                    </tbody>
                                </table> 
                                <table v-if="isEditMode && !isBodyEditing" class="web-hook-body-table-edit table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;"> 
                                                <div  @click="allowToEditBody()" class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg  data-v-7efae477="" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-pen-fill">
                                                        <path data-v-7efae477="" fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"></path>
                                                    </svg>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="Object.keys(bodyValuesObj).length">
                                        <template v-for="(value, name, index) in bodyValuesObj">
                                            <tr :key="index">
                                                <td>{{name}}</td>
                                                <td>{{value}}</td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </tbody>    
                                </table> 
                                <table v-if="isEditMode && isBodyEditing" class="web-hook-body-table-editable table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div @click="addOneRowForHeader('web-hook-body-table-editable')" class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(row, index) in editableBodyRowArr">
                                            <tr :key="index">
                                                <td>
                                                    <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td>
                                                    <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td style='text-align: start; padding: 0px 0px 0px 18px;'>
                                                    <div class="placed-edit-icon" @click="removeRowFromTable('web-hook-body-table-editable', index)" style="display: flex;align-items: center;justify-content: center;">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                        </svg>
                                                    </div>  
                                                </td>
                                            </tr> 
                                        </template> 
                                    </tbody>
                                </table>
                                <div v-if="isEditMode && this.isBodyEditing" class="web-hook-primary-btn-style" style="padding-inline-end:15px;">
                                    <button @click="updateWebHookFields('body')" class="btn btn-outline-primary" style="float:inline-end">
                                    {{$t('Save')}}
                                    </button>
                                    <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="cancelEditedTableChanges('editing-body-row')" style="float:inline-end">{{$t('Cancel')}}</button>
                                </div>   
                            </div>    
                        </div>                       
                        <div v-show="activeIndex == 'alias'" class="header-section">
                            <div class="common-input-field description-edit-icon-visibility" style="position:relative;padding:0px 20px 20px 20px;">
                                <table v-if="!isEditMode" class="web-hook-alias-table table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Alias')}}</th>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div class="placed-edit-icon" @click="addOneRowForHeader('web-hook-alias-table')" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div>    
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in addingAliasRowArr" :key="index">
                                            <td>
                                                <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td>
                                                <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                            </td>
                                            <td style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div class="placed-edit-icon" @click="removeRowFromTable('web-hook-alias-table', index)" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"  width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                    </svg>
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> 
                                <table v-if="isEditMode && !isAliasEditing" class="web-hook-alias-table-edit table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Alias')}}</th>
                                            <th width="46%">{{$t('key')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div @click="allowToEditAlias()" class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg  data-v-7efae477="" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-pen-fill">
                                                        <path data-v-7efae477="" fill-rule="evenodd" d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"></path>
                                                    </svg>
                                                </div>    
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="Object.keys(aliasValuesObj).length">
                                        <template v-for="(value, name, index) in aliasValuesObj">
                                            <tr :key="index">
                                                <td>{{name}}</td>
                                                <td>{{value}}</td>
                                                <td></td>
                                            </tr>
                                        </template>
                                    </tbody>    
                                </table> 
                                <table v-if="isEditMode && isAliasEditing" class="web-hook-alias-table-editable table-scroll small-first-col">
                                    <thead>
                                        <tr>
                                            <th width="46%">{{$t('Key')}}</th>
                                            <th width="46%">{{$t('Value')}}</th>
                                            <th width="8%" style="text-align: start; padding: 0px 0px 0px 18px;">
                                                <div @click="addOneRowForHeader('web-hook-alias-table-editable')" class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                    <svg xmlns="http://www.w3.org/2000/svg"  width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                                                    </svg>
                                                </div>    
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(row, index) in editableAliasRowArr">
                                            <tr :key="index">
                                                <td>
                                                    <input v-model="row.key" class="rounded text-light input-fields row-key" type="text" placeholder="Enter Key" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td>
                                                    <input v-model="row.value" class="rounded text-light input-fields row-value" type="text" placeholder="Enter Value" autocomplete="off" style="float:inline-start;width:100%;"/>
                                                </td>
                                                <td style="text-align: start; padding: 0px 0px 0px 18px;">
                                                    <div class="placed-edit-icon" style="display: flex;align-items: center;justify-content: center;">
                                                        <svg xmlns="http://www.w3.org/2000/svg"  @click="removeRowFromTable('web-hook-alias-table-editable', index)" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                                                        </svg>
                                                    </div>  
                                                </td>
                                            </tr> 
                                        </template> 
                                    </tbody>
                                </table>
                                 <div v-if="isEditMode && this.isAliasEditing" class="web-hook-primary-btn-style" style="padding-inline-end:15px;">
                                    <button @click="updateWebHookFields('alias')" class="btn btn-outline-primary" style="float:inline-end">
                                    {{$t('Save')}}
                                    </button>
                                    <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="cancelEditedTableChanges('editing-alias-row')" style="float:inline-end">{{$t('Cancel')}}</button>
                                </div>   
                            </div>    
                        </div>                       
                    </div>  
                </div> 
                <div style="display:inline-block;width:100%;">
                    <div class="col-md-4 custom-control custom-switch" style="display: inline-block;float:inline-start;text-align:start;padding:0px 20px;">
                         <h6 style="display: inline-block;float:inline-start;height:40px;align-items:center;margin:0px 5px;text-align:start;color:#757575;width: 92px;position: relative;top: 3px;"> {{$t('Enable')}} </h6>
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="enableDisable"
                            ref="webHookEnable"
                            :checked="isEnbled"
                            @click="updateWebHookStatus()"
                        />
                        <label class="custom-control-label" for="enableDisable">
                        </label>    
                          
                    </div>

                </div>   
           </div>  
        </div>
        <div v-if="!isEditMode" class="web-hook-primary-btn-style" style="padding-inline-end:15px;">
            <button v-if="!isEditMode" @click="addWebHook()" class="btn btn-outline-primary" style="float:inline-end">
            {{$t('Save')}}
            </button>
            <button class="btn btn-outline-secondary mr-3" data-dismiss="modal"  v-on:click="changeToSelectedwebhookComponent('show-webhook')" style="float:inline-end">{{$t('Cancel')}}</button>
        </div>
   </div>
</template> 

<script>
    import { mapActions, mapMutations } from "vuex";
    import BackButton from "../core/backButton.vue";
    import Utils from "../../components.utils.js";
    import EditIcon from "../core/InlineEditField.vue";
    import SaveIcon from "../core/InlineSaveField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";
    import {NotifierConstants} from "../../components.constants.js";
    // import Multiselect from "vue-multiselect";

    export default({
        data(){
            return {
                activeIndex : "header",
                hookscriptName:"",
                webHookUrl:"",
                headerValuesObj:{},
                bodyValuesObj:{},
                aliasValuesObj:{},
                isHeadersEditing:false,
                isBodyEditing:false,
                isAliasEditing:false,
                isWebHookNameEditing:false,
                isWebHookUrlEditing:false,
                webHookNameEdited:"",
                addingHeaderRowArr : [{'key':'','value':''}],
                editableHeaderRowArr : [],
                addingBodyRowArr : [{'key':'','value':''}],
                editableBodyRowArr : [],
                addingAliasRowArr : [{'key':'','value':''}],
                editableAliasRowArr : [],
                isEnbled:true,
                isWorkflowEnabled:false,

            }
        },
        components: {
            "back-button":BackButton,
            "edit-icon": EditIcon,
            "save-icon": SaveIcon,
            "cancel-icon": CancelIcon,
            // Multiselect
        },  
        
        created(){
            this.registerforWebsocketNotifications();
            // this.getTriggersList();
            setTimeout(()=>{
                if(this.isEditMode){
                    this.setWebHookValues();
                }   
            },500);     
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },

        props: ["selectedWebHookName", "selectedWebhookInfo", "isEditMode", "triggersList"],
        methods : {
            changeToSelectedwebhookComponent(compName, payload={}){
                this.$emit("changeToSelectedwebhookComponent", compName, payload)
            },

            switchHeaderAndBodyTab(tabName){
                this.activeIndex = tabName;
            },

            addOneRowForHeader(tableName){
                console.log(tableName)
                if(tableName == "web-hook-headers-table"){
                    this.addingHeaderRowArr.push({'key':'', 'value':''});
                }else if(tableName == "web-hook-headers-table-editable"){
                    this.editableHeaderRowArr.push({'key':'', 'value':''});
                }else if(tableName == "web-hook-body-table"){
                    this.addingBodyRowArr.push({'key':'', 'value':''});
                    
                }else if(tableName == "web-hook-body-table-editable"){
                    this.editableBodyRowArr.push({'key':'', 'value':''});
                }else if(tableName == "web-hook-alias-table"){
                    this.addingAliasRowArr.push({'key':'', 'value':''});
                }else if(tableName == "web-hook-alias-table-editable"){
                    this.editableAliasRowArr.push({'key':'', 'value':''});
                } 
                
            },

            removeRowFromTable(tableName, rowCount){
                if(tableName == "web-hook-headers-table"){
                     if(this.addingHeaderRowArr.length>= rowCount && ![undefined, null].includes(this.addingHeaderRowArr[rowCount])){
                        this.addingHeaderRowArr.splice(rowCount, 1)
                    } 
                }else if(tableName == "web-hook-headers-table-editable"){
                    if(this.editableHeaderRowArr.length>= rowCount && ![undefined, null].includes(this.editableHeaderRowArr[rowCount])){
                        this.editableHeaderRowArr.splice(rowCount, 1)
                    }  
                }else if(tableName == "web-hook-body-table"){
                    if(this.addingBodyRowArr.length>= rowCount && ![undefined, null].includes(this.addingBodyRowArr[rowCount])){
                        this.addingBodyRowArr.splice(rowCount, 1)
                    } 
                }else if(tableName == "web-hook-body-table-editable"){
                    if(this.editableBodyRowArr.length>= rowCount && ![undefined, null].includes(this.editableBodyRowArr[rowCount])){
                        this.editableBodyRowArr.splice(rowCount, 1)
                    } 
                }else if(tableName == "web-hook-alias-table"){
                    if(this.addingAliasRowArr.length>= rowCount && ![undefined, null].includes(this.addingAliasRowArr[rowCount])){
                        this.addingAliasRowArr.splice(rowCount, 1)
                    } 
                }else if(tableName == "web-hook-alias-table-editable"){
                    if(this.editableAliasRowArr.length>= rowCount && ![undefined, null].includes(this.editableAliasRowArr[rowCount])){
                        this.editableAliasRowArr.splice(rowCount, 1)
                    } 
                } 
            },
            
            /*toggletriggers(){
                let triggersObj = document.getElementById("triggersBtn");
                if(triggersObj.checked){
                    this.$refs.triggersList.style.display = "none";
                    this.$refs.triggersList.style.transition = "0.5s"; 
                }else{
                    this.$refs.triggersList.style.display = "inline-block";
                    this.$refs.triggersList.style.transition = "0.5s"; 
                }   
                if(this.isEditMode){
                    this.updateWebHookFields("isWorkflowTask", this.$refs.tiggersEnable.checked);
                }    
            },*/

            toggletriggers() {
                this.isWorkflowEnabled = this.$refs.tiggersEnable.checked;

                if (this.isEditMode) {
                    this.updateWebHookFields(
                        "isWorkflowTask",
                        this.isWorkflowEnabled
                    );
                }
            },

            updateWebHookStatus(){
                if(this.isEditMode)
                    this.updateWebHookFields("enable", this.$refs.webHookEnable.checked);
                    this.isEnbled = this.$refs.webHookEnable.checked;
            },

            addWebHook(){
                let postData={};
                if(this.hookscriptName == ""){
                    this.$toast.error("Hook script Name is Empty");
                    return false;
                }else if(![null, undefined].includes(this.hookscriptName)){
                    postData["hookscript_name"] = this.hookscriptName.trim();
                }
                
                postData["notifier_type"] = "http";

                let httpInfo = {};
                httpInfo["method"] = "post"

                
                if(this.webHookUrl == ""){
                    this.$toast.error("Hook script URL is Empty");
                    return false;
                }else if(![null, undefined].includes(this.webHookUrl)){
                    // eslint-disable-next-line no-useless-escape
                    var urlRes = this.webHookUrl.match(/((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i);
                    if(![undefined, null].includes(urlRes)){
                        httpInfo["url"] = this.webHookUrl;
                    }else{
                        this.$toast.error("Invalid URL");
                        return false;
                    }    
                    //  httpInfo["url"] = this.webHookUrl;
                }

                //Headers
                let headerObj = {};
                let headersTable = document.getElementsByClassName("web-hook-headers-table")[0].childNodes[1];
                for (let i=0; i<headersTable.rows.length;i++) {
                    if(headersTable.rows[i].cells.length>0){
                        let row = headersTable.rows[i];
                        if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                            && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                            headerObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                        }    
                    }
                }   

                if(Object.keys(headerObj).length >0){
                    httpInfo["headers"]  = headerObj;
                }

                //body
                let bodyObj = {};
                let bodyTable = document.getElementsByClassName("web-hook-body-table")[0].childNodes[1];
                for (let i=0; i<bodyTable.rows.length;i++) {
                    console.log(bodyTable.rows[i].cells[0]);
                    if(bodyTable.rows[i].cells.length>0){
                        let row = bodyTable.rows[i];
                        if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                            && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                            bodyObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                        }
                    }
                }   

                if(Object.keys(bodyObj).length >0){
                    httpInfo["form_data"]  = bodyObj;
                }

                //alias
                let aliasValuesObj = {};
                let aliasTable = document.getElementsByClassName("web-hook-alias-table")[0].childNodes[1];
                for (let i=0; i<aliasTable.rows.length;i++) {
                    console.log(aliasTable.rows[i].cells[0]);
                    if(aliasTable.rows[i].cells.length>0){
                        let row = aliasTable.rows[i];
                        if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                            && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                            aliasValuesObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                        }
                    }
                }  
                if(Object.keys(aliasValuesObj).length >0){
                    httpInfo["replace_keys"]  = aliasValuesObj;
                }

                postData["http_info"] = httpInfo;

                //selectedTriggers

                postData["isWorkflowTask"] = this.$refs.tiggersEnable.checked;
                // if(this.$refs.tiggersEnable.checked == true){
                   if(!this.$refs.tiggersEnable.checked){ 
                    let triggerItemList = document.getElementsByClassName("triggers-item"); 
                    let selectedTriggersList = [];
                    for(let i=0; i<triggerItemList.length; i++){
                        if(triggerItemList[i].childNodes[0].checked == true){
                            console.log(triggerItemList[i].childNodes[0].getAttribute("id"))
                            selectedTriggersList.push(triggerItemList[i].childNodes[0].getAttribute("id"));
                        }
                    }   

                    if(selectedTriggersList.length>0){
                        postData["trigger_id_list"] = selectedTriggersList;
                    }
                }    

                postData["enable"] = this.$refs.webHookEnable.checked;
                
                this.addNewWebHook(postData).then((data) => {
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$toast.success(data.message);
                        this.changeToSelectedwebhookComponent('show-webhook')
                    } else {
                        this.$toast.error(data.message);  
                    }
                });

            },

            updateTriggersValue(triggerId){
                if(this.isEditMode){
                    let triggersListTemp = this.selectedWebhookInfo.trigger_id_list;
                    if(document.getElementById(triggerId).checked == true){
                        if(triggersListTemp.indexOf(triggerId) == -1){
                            triggersListTemp.push(triggerId);
                        }
                    }else{
                        if(triggersListTemp.indexOf(triggerId) >=0){
                            let index = triggersListTemp.indexOf(triggerId);
                            triggersListTemp.splice(index, 1);
                        }
                    }

                    this.updateWebHookFields("trigger_id_list", triggersListTemp)
                }
            },

            updateWebHookFields(field, value){
                let payload={};
                // payload = this.proxyConfig;
                // payload.params = commentPostdata;

                let selectedWebhhokId = this.selectedWebhookInfo._id;
                payload.webhookId = selectedWebhhokId;
                let reviewObj = {};
                if(field == "headers"){
                    let headerObj = {};
                    let headersTable = document.getElementsByClassName("web-hook-headers-table-editable")[0].childNodes[1];
                    for (let i=0; i<headersTable.rows.length;i++) {
                        console.log(headersTable.rows[i].cells[0]);
                        if(headersTable.rows[i].cells.length>0){
                            let row = headersTable.rows[i];
                            if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                                && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                                headerObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                            }    
                        }
                    }   

                    if(headerObj){
                        let headersPutObj = {};
                        headersPutObj["headers"] = headerObj;
                        reviewObj["http_info"] = headersPutObj;
                        this.isHeadersEditing = false;
                    }
                }else  if(field == "body"){
                    let bodyObj = {};
                    let bodyTable = document.getElementsByClassName("web-hook-body-table-editable")[0].childNodes[1];
                    for (let i=0; i<bodyTable.rows.length;i++) {
                        console.log(bodyTable.rows[i].cells[0]);
                        if(bodyTable.rows[i].cells.length>0){
                            let row = bodyTable.rows[i];
                            if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                                && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                                bodyObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                            }    
                        }
                    }   

                    if(bodyObj){
                        let bodyPutObj = {};
                        bodyPutObj["form_data"] = bodyObj;
                        reviewObj["http_info"] = bodyPutObj;
                        this.isBodyEditing = false;
                    }
                }else if(field == "alias"){
                      
                     let aliasObj = {};
                    let aliasTable = document.getElementsByClassName("web-hook-alias-table-editable")[0].childNodes[1];
                    for (let i=0; i<aliasTable.rows.length;i++) {
                        console.log(aliasTable.rows[i].cells[0]);
                        if(aliasTable.rows[i].cells.length>0){
                            let row = aliasTable.rows[i];
                            if(!["", undefined,null].includes(row.cells[0].querySelector('.row-key').value) 
                                && !["", undefined, null].includes(row.cells[1].querySelector('.row-value').value)){
                                aliasObj[row.cells[0].querySelector('.row-key').value] = row.cells[1].querySelector('.row-value').value;
                            }    
                        }
                    }   

                    if(aliasObj){
                        let aliasPutObj = {};
                        aliasPutObj["replace_keys"] = aliasObj;
                        reviewObj["http_info"] = aliasPutObj;
                        this.isAliasEditing = false;
                    }  
                }else if(field == "url"){
                    let urlPutObj = {};

                    // eslint-disable-next-line no-useless-escape
                    var urlRes = value.match(/((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i);
                    if(![undefined, null].includes(urlRes)){
                        urlPutObj["url"] = value;
                        reviewObj["http_info"] = urlPutObj;
                    }else{
                        this.$toast.error("Invalid URL");
                        return false;
                    } 

                        
                }else{
                    reviewObj[field] = value;
                }    
                payload.params = reviewObj;
                this.updateWebhookData(payload).then((data) => {
                    this.cancelSelectedWebHookFields(field)
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        if(data.message) this.$toast.success(data.message);
                        // this.$toast("Task is updated successfully");
                    } else {
                    if(data.message) this.$toast.error(data.message);
                    }
                });
            },

            cancelSelectedWebHookFields(keyName) {
                if(keyName == "hookscript_name"){
                    this.isWebHookNameEditing = false;
                }else if(keyName == "url"){
                    this.isWebHookUrlEditing = false;
                    this.webHookUrl = this.selectedWebhookInfo.http_info.url;
                }
                // this.reviewDetails[keyName] = this.proxyCOnfigTemp1[keyName];
            },

            cancelEditedTableChanges(className){
                if(className == "editing-header-row"){
                    this.isHeadersEditing = false;
                }else if(className == "editing-body-row"){
                    this.isBodyEditing = false;
                }else if(className == "editing-alias-row"){
                    this.isAliasEditing = false;
                }      
            },

            setWebHookValues(){
                    if(Object.keys(this.selectedWebhookInfo).length>0){
                        this.hookscriptName = this.selectedWebhookInfo.hookscript_name;
                        this.webHookUrl = this.selectedWebhookInfo.http_info.url;

                        // document.getElementById("enableDisable").checked = this.selectedWebhookInfo.enable;
                        this.isEnbled = this.selectedWebhookInfo.enable;
                        
                        /*document.getElementById("triggersBtn").checked = this.selectedWebhookInfo.isWorkflowTask;

                        if(this.selectedWebhookInfo.isWorkflowTask){
                            
                            this.$refs.triggersList.style.display = "none";
                            this.$refs.triggersList.style.transition = "0.5s";
                        
                        }else{
                            this.$refs.triggersList.style.display = "inline-block";
                            this.$refs.triggersList.style.transition = "0.5s";

                            let triggersList = this.selectedWebhookInfo.trigger_id_list;
                            if(triggersList.length>0){
                                let triggerItemList = document.getElementsByClassName("triggers-item"); 
                                for(let i=0; i<triggerItemList.length; i++){
                                    let triggerId = triggerItemList[i].childNodes[0].getAttribute("id");

                                    if(triggersList.indexOf(triggerId)>=0){
                                        // selectedTriggersList.push(triggerItemList[i].childNodes[0].getAttribute("id"));
                                        triggerItemList[i].childNodes[0].setAttribute("checked", true);
                                    }
                                } 
                            } 
                        } */
                       
                        this.isWorkflowEnabled = this.selectedWebhookInfo.isWorkflowTask;

                        document.getElementById("triggersBtn").checked =
                            this.isWorkflowEnabled;

                        if (!this.isWorkflowEnabled) {
                            let triggersList =
                                this.selectedWebhookInfo.trigger_id_list;

                            if (triggersList.length > 0) {
                                let triggerItemList =
                                    document.getElementsByClassName("triggers-item");

                                for (let i = 0; i < triggerItemList.length; i++) {
                                    let triggerId =
                                        triggerItemList[i]
                                            .childNodes[0]
                                            .getAttribute("id");

                                    if (triggersList.indexOf(triggerId) >= 0) {
                                        triggerItemList[i]
                                            .childNodes[0]
                                            .setAttribute("checked", true);
                                    }
                                }
                            }
                        }

                        if(Object.keys(this.selectedWebhookInfo.http_info).length 
                            && Object.keys(this.selectedWebhookInfo.http_info.headers).length){
                                this.headerValuesObj = this.selectedWebhookInfo.http_info.headers;

                                if(Object.keys(this.selectedWebhookInfo.http_info.headers).length>0){
                                    for(let key in this.selectedWebhookInfo.http_info.headers){
                                        this.editableHeaderRowArr.push({'key':key, 'value':this.selectedWebhookInfo.http_info.headers[key]});        
                                    }
                                }
                                
                        }

                        if(Object.keys(this.selectedWebhookInfo.http_info).length 
                            && Object.keys(this.selectedWebhookInfo.http_info.form_data).length){
                                this.bodyValuesObj = this.selectedWebhookInfo.http_info.form_data;

                                if(Object.keys(this.selectedWebhookInfo.http_info.form_data).length>0){
                                    for(let key in this.selectedWebhookInfo.http_info.form_data){
                                        this.editableBodyRowArr.push({'key':key, 'value':this.selectedWebhookInfo.http_info.form_data[key]});        
                                    }
                                }
                        }

                        if(Object.keys(this.selectedWebhookInfo.http_info).length 
                            && Object.keys(this.selectedWebhookInfo.http_info.replace_keys).length){
                                this.aliasValuesObj = this.selectedWebhookInfo.http_info.replace_keys;

                                if(Object.keys(this.selectedWebhookInfo.http_info.replace_keys).length>0){
                                    for(let key in this.selectedWebhookInfo.http_info.replace_keys){
                                        this.editableAliasRowArr.push({'key':key, 'value':this.selectedWebhookInfo.http_info.replace_keys[key]});        
                                    }
                                }
                        }
                    }      
            },

            allowToEditHeaders(){
                this.isHeadersEditing = true;
                this.$nextTick(()=>{
                    if(Object.keys(this.headerValuesObj).length>0){
                        let count = 0;
                        for(let key in this.headerValuesObj){
                            let table = document.getElementsByClassName("web-hook-headers-table-editable")[0].childNodes[1];
                                table.rows[count].cells[0].querySelector('.row-key').value = key;
                                table.rows[count].cells[1].querySelector('.row-value').value = this.headerValuesObj[key];
                            count ++;
                        }
                    }
                });    
            },

            allowToEditBody(){
                this.isBodyEditing = true;
                this.$nextTick(()=>{
                    if(Object.keys(this.bodyValuesObj).length>0){
                        let count = 0;
                        for(let key in this.bodyValuesObj){
                            let table = document.getElementsByClassName("web-hook-body-table-editable")[0].childNodes[1];
                            table.rows[count].cells[0].querySelector('.row-key').value = key;
                            table.rows[count].cells[1].querySelector('.row-value').value = this.bodyValuesObj[key];
                            count ++;
                        }
                    }
                });    
            },

            allowToEditAlias(){
                this.isAliasEditing = true;
                this.$nextTick(()=>{
                    if(Object.keys(this.aliasValuesObj).length>0){
                        let count = 0;
                        for(let key in this.aliasValuesObj){
                            let table = document.getElementsByClassName("web-hook-alias-table-editable")[0].childNodes[1];
                            table.rows[count].cells[0].querySelector('.row-key').value = key;
                            table.rows[count].cells[1].querySelector('.row-value').value = this.aliasValuesObj[key];
                            count ++;
                        }
                    }
                });    
            },

            handleWebHookNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                let messageInfo = notification.message;
                 if (notification.message_type == NotifierConstants.webHookUpdateNotification){
                    if(this.selectedWebhookInfo._id == messageInfo.hookscript_id){
                        if(Object.keys(messageInfo).includes("hookscript_name")){
                            this.$set(this.selectedWebhookInfo, "hookscript_name", messageInfo.hookscript_name)
                        }

                        /*if(Object.keys(messageInfo).includes("isWorkflowTask")){
                            this.$set(this.selectedWebhookInfo, "isWorkflowTask", messageInfo.isWorkflowTask);
                            document.getElementById("triggersBtn").checked = messageInfo.isWorkflowTask;

                            if(messageInfo.isWorkflowTask == true){
                                this.$refs.triggersList.style.display = "none";
                                this.$refs.triggersList.style.transition = "0.5s"; 
                            }else{
                                this.$refs.triggersList.style.display = "inline-block";
                                this.$refs.triggersList.style.transition = "0.5s";  
                            } 
                        }*/

                        if (Object.keys(messageInfo).includes("isWorkflowTask")) {
                            this.$set(
                                this.selectedWebhookInfo,
                                "isWorkflowTask",
                                messageInfo.isWorkflowTask
                            );

                            this.isWorkflowEnabled =
                                messageInfo.isWorkflowTask;

                            document.getElementById("triggersBtn").checked =
                                this.isWorkflowEnabled;
                        }


                         if(Object.keys(messageInfo).includes("enable")){
                            this.$set(this.selectedWebhookInfo, "enable", messageInfo.enable);
                            document.getElementById("enableDisable").checked = this.selectedWebhookInfo.enable;
                        }

                        if(Object.keys(messageInfo).includes("trigger_id_list")){

                            this.$set(this.selectedWebhookInfo, "trigger_id_list", messageInfo.trigger_id_list);
                            if(messageInfo.trigger_id_list.length>0){
                                let triggerItemList = document.getElementsByClassName("triggers-item"); 
                                for(let i=0; i<triggerItemList.length; i++){
                                    let triggerId = triggerItemList[i].childNodes[0].getAttribute("id");

                                    if(messageInfo.trigger_id_list.indexOf(triggerId)>=0){
                                        // selectedTriggersList.push(triggerItemList[i].childNodes[0].getAttribute("id"));
                                        triggerItemList[i].childNodes[0].setAttribute("checked", true);
                                    }else{
                                        triggerItemList[i].childNodes[0].removeAttribute("checked");
                                    }
                                } 
                            } 
                        }

                        if(Object.keys(messageInfo).includes("trigger_id_list")){
                            this.$set(this.selectedWebhookInfo, "trigger_id_list", messageInfo.trigger_id_list)
                        }

                        if(Object.keys(messageInfo).includes("http_info") && Object.keys(messageInfo.http_info).includes("url")){
                            this.$set(this.selectedWebhookInfo.http_info, "url", messageInfo.http_info.url);
                            this.webHookUrl = messageInfo.http_info.url;
                        }

                        if(Object.keys(messageInfo).includes("http_info") && Object.keys(messageInfo.http_info).includes("headers")){
                            this.$set(this.selectedWebhookInfo.http_info, "headers", messageInfo.http_info.headers)
                            this.headerValuesObj = messageInfo.http_info.headers;
                            if(this.isHeadersEditing == true){
                                this.$nextTick(()=>{
                                    if(Object.keys(this.headerValuesObj).length>0){
                                        let count = 0;
                                        for(let key in this.headerValuesObj){
                                            let table = document.getElementsByClassName("web-hook-headers-table-editable")[0].childNodes[1];
                                                table.rows[count].cells[0].querySelector('.row-key').value = key;
                                                table.rows[count].cells[1].querySelector('.row-value').value = this.headerValuesObj[key];
                                            count ++;
                                        }
                                    }
                                });   
                            }     
                        }

                        if(Object.keys(messageInfo).includes("http_info") && Object.keys(messageInfo.http_info).includes("form_data")){
                            this.$set(this.selectedWebhookInfo.http_info, "form_data", messageInfo.http_info.form_data)
                            this.bodyValuesObj = messageInfo.http_info.form_data;
                            if(this.isBodyEditing == true){
                                this.$nextTick(()=>{
                                    if(Object.keys(this.bodyValuesObj).length>0){
                                        let count = 0;
                                        for(let key in this.bodyValuesObj){
                                            let table = document.getElementsByClassName("web-hook-body-table-editable")[0].childNodes[1];
                                                table.rows[count].cells[0].querySelector('.row-key').value = key;
                                                table.rows[count].cells[1].querySelector('.row-value').value = this.bodyValuesObj[key];
                                            count ++;
                                        }
                                    }
                                }); 
                            }      
                        }

                        if(Object.keys(messageInfo).includes("http_info") && Object.keys(messageInfo.http_info).includes("replace_keys")){
                            this.$set(this.selectedWebhookInfo.http_info, "replace_keys", messageInfo.http_info.replace_keys)
                            this.aliasValuesObj = messageInfo.http_info.replace_keys;
                            
                            if(this.isAliasEditing == true){
                                this.$nextTick(()=>{
                                    if(Object.keys(this.aliasValuesObj).length>0){
                                        let count = 0;
                                        for(let key in this.aliasValuesObj){
                                            let table = document.getElementsByClassName("web-hook-alias-table-editable")[0].childNodes[1];
                                            table.rows[count].cells[0].querySelector('.row-key').value = key;
                                            table.rows[count].cells[1].querySelector('.row-value').value = this.aliasValuesObj[key];
                                            count ++;
                                        }
                                    }
                                });  
                            }    

                        }

                    }
                }
            },

            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:[NotifierConstants.webHookCreateNotification, NotifierConstants.webHookUpdateNotification, NotifierConstants.webHookDeleteNotification],
                    callback:this.handleWebHookNotification,
                    parent: "webhook"});
            },

             unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:[NotifierConstants.webHookCreateNotification, NotifierConstants.webHookUpdateNotification, NotifierConstants.webHookDeleteNotification],
                    callback:this.handleWebHookNotification,
                    parent: "webhook"});
             },

            ...mapActions("webHook", ["getTriggersFromServer", "addNewWebHook", "updateWebhookData"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        }
    })
</script>


<style lang="scss" scoped>
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

    .input-fields{
        background: #1a1e21!important;
        height: 40px;
        float: inline-end;
        padding-inline-start: 12px;
        margin: 0 3% 0 0;
        padding-bottom: 2px;
        border: 1px solid #4a4a4a;
    }

    .custom-control-input{
        z-index:999;
    }

    .category-label {
        padding-top: 2px;
        font-weight: 600;
        display: block !important;
    }

    .category-head {
        float: inline-start;
        text-align: initial;
        width: 100%;
    }

    .custom-control-label::before, .custom-file-label, .custom-select {
        transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    input[type='checkbox']:after{
        line-height: 1.5em;
        content: '';
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: 5px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type='checkbox']:checked:after{
        content: '✔';
        color: $active-blue !important;
        position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: all .2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top:2px;
    }

    .webhook-triggers-div{
        display: inline-block;
        float: inline-start;
        text-align: start;
        position: relative;
        inset-inline-start: 15px;
    }

    .custom-control-input {
        position: absolute;
        inset-inline-start: 0;
        z-index: -1;
        width: 1rem;
        height: 1.25rem;
        opacity: 0;
    }

    .comm-field-div{
        display: inline-block;
        margin:10px 0px;
    }

    .edit-icon{
        visibility: hidden;
    }

    .edit-icon-visibility{
        width: 100%;
    }

    .edit-icon-visibility:hover{
        .edit-icon{
            visibility: visible;
        } 
    }

    .breadcrumb{
        padding: 0.75rem 1rem !important;
        background: #1a1e21 !important;
    }

    .inactiveTab:hover{
        color:$text-color !important;
    }
    .activeTab{
        // background: #272727 !important;
        color:$active-blue  !important;
        border-bottom: 2px solid $active-blue ;
        font-weight: 500;
        font-size:15px;
    }

    #webhookNavbar{
        padding:0px 20px;
        margin-bottom: 10px;
        .navbar-nav{
            a{
                color: #757575;
            }
        }
    }

    .web-hook-primary-btn-style {
        margin-top: 1%;
        // position: absolute;
        // bottom: 6px;
        inset-inline-end: 0%;
        height:50px;
        background: $primary-background;
        width:100%;
        z-index:9;
        button {
            height: $button-height;
            width: 70px;
            font-size:14px;
            margin-top:7px;
        }
        .btn-outline-secondary{
            float:inline-end;
        }
        .btn-outline-primary{
            float:inline-end;
            margin-inline-end:15px;
        }
    }

    .web-hook-headers-table, .web-hook-body-table, .web-hook-alias-table, 
    .web-hook-headers-table-edit-readonly, .web-hook-body-table-edit, .web-hook-alias-table-edit,
    .web-hook-headers-table-editable, .web-hook-body-table-editable, .web-hook-alias-table-editable{
        width:100%;
        thead{
            tr{
                th{
                    padding: 10px;
                    color: #757575;
                }
                th:not(:last-child){
                    border: 1px solid #4a4a4a !important;
                    background: #373737;
                    color: #b5b5b5;
                }
            }
        }
        tbody{
            tr{
                td{
                    padding: 10px;
                    input{
                        border:none;
                    }
                    input:focus{
                        border: 1px solid #4a4a4a;
                    }
                    svg{
                        fill:#797979;
                    }
                    svg:hover{
                        fill:#fff !important;
                    }
                }
                td:not(:last-child){
                    border: 1px solid #4a4a4a !important;
                }
                
            }
        }
    }

    .table-bordered{
        border: 1px solid #4a4a4a !important;
        thead{
            tr{
                th{
                    border-bottom: none !important;
                    border: 1px solid #4a4a4a;
                }
            }
        }
        tbody{
            tr{
                td{
                    border-bottom: none !important;
                    border: 1px solid #4a4a4a;
                }
            }
        }
    }

    .custom-switch{
      padding-inline-start: 5%;
    }
    
    .custom-control-label::before {
        background-color: $primary-background;
    }

    .comm-helper-label{
        font-size: 12px;
        color: $secondary-text-color;
    }

     ::-webkit-scrollbar {
      width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }

    ::-webkit-input-placeholder { /* Edge */
        color: red;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: red;
    }

    .input-fields::placeholder {
        color: #545454 !important;
    }

    .placed-edit-icon{
        background: #d1d2d31a;
        padding: 4px;
        height: 40px;
        width: 40px;
        border-radius: 4px;
    }

    .placed-edit-icon:hover{
        background: #fdfeff54 !important;
        svg{
            fill:#fff;
        }
    }

     ::v-deep {

        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: #eee !important;
            height:100%;
        }
        .mx-input-wrapper{
        width:100%;
        height:100%;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $primary-background !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: #505050 !important;
        }
        .mx-datepicker-range{
        width:100%;
        height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
        width:100% !important;
        padding: 0 !important;
        border:$border-color !important;
        height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }

       .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-end;
            margin-inline-start:5px;
            position: relative;
            top:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
    }

</style>    